import { useState, useEffect } from 'react';

interface NavigationProps {
  isScrolled: boolean;
}

export default function Navigation({ isScrolled }: NavigationProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isMobileMenuOpen]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md h-20 md:h-28' : 'bg-transparent h-20 md:h-28'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-full flex items-center justify-between">
        {/* Logo and Catchphrase */}
        <div className="flex items-center space-x-3 md:space-x-4">
          <img
            src="https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/10d9fc1b609b54364963a5ea239520dd.png"
            alt="Bucket List Golf"
            className="h-16 md:h-24 w-auto"
          />
          <span
            className={`hidden sm:block text-xs md:text-sm font-light italic transition-colors ${
              isScrolled ? 'text-gray-600' : 'text-white'
            }`}
          >
            Where the Game Takes Us...
          </span>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-8">
          <a
            href="#about"
            className={`text-sm font-medium transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-emerald-600' : 'text-white hover:text-emerald-300'
            }`}
          >
            About
          </a>
          <a
            href="#how-to-register"
            className={`text-sm font-medium transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-emerald-600' : 'text-white hover:text-emerald-300'
            }`}
          >
            How to Register
          </a>
          <a
            href="#faq"
            className={`text-sm font-medium transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-emerald-600' : 'text-white hover:text-emerald-300'
            }`}
          >
            FAQ
          </a>
          <a
            href="#contact"
            className={`text-sm font-medium transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-emerald-600' : 'text-white hover:text-emerald-300'
            }`}
          >
            Contact
          </a>
          <a
            href="#register-multiple"
            className="bg-emerald-600 text-white px-6 py-2 rounded-md text-sm font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Register Now
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={`md:hidden p-2 rounded-md transition-colors ${
            isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
          }`}
          aria-label="Toggle menu"
        >
          <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden fixed inset-0 top-20 bg-white z-40 overflow-y-auto">
          <div className="flex flex-col space-y-1 p-4">
            <a
              href="#about"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 px-4 py-3 rounded-md text-base font-medium transition-colors cursor-pointer"
            >
              About
            </a>
            <a
              href="#how-to-register"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 px-4 py-3 rounded-md text-base font-medium transition-colors cursor-pointer"
            >
              How to Register
            </a>
            <a
              href="#faq"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 px-4 py-3 rounded-md text-base font-medium transition-colors cursor-pointer"
            >
              FAQ
            </a>
            <a
              href="#contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 px-4 py-3 rounded-md text-base font-medium transition-colors cursor-pointer"
            >
              Contact
            </a>
            <a
              href="#register-multiple"
              onClick={() => setIsMobileMenuOpen(false)}
              className="bg-emerald-600 text-white px-4 py-3 rounded-md text-base font-semibold hover:bg-emerald-700 transition-colors text-center cursor-pointer mt-4"
            >
              Register Now
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
